"use client"
import UseSticky from "@/hooks/UseSticky";
import { useState, useEffect, useCallback } from "react";

const ScrollToTop = () => {
   const { sticky }: { sticky: boolean } = UseSticky();

   const [showScroll, setShowScroll] = useState(false);

   const checkScrollTop = useCallback(() => {
      if (typeof window === "undefined") return;
      if (!showScroll && window.pageYOffset > 400) {
         setShowScroll(true);
      } else if (showScroll && window.pageYOffset <= 400) {
         setShowScroll(false);
      }
   }, [showScroll]);

   const scrollTop = () => {
      if (typeof window === "undefined") return;
      window.scrollTo({ top: 0, behavior: "smooth" });
   };

   useEffect(() => {
      if (typeof window === "undefined") return;
      window.addEventListener("scroll", checkScrollTop);
      return () => window.removeEventListener("scroll", checkScrollTop);
   }, [checkScrollTop]);

   return (
      <>
         <button
            onClick={scrollTop}
            className={`scroll-top scroll-to-target ${sticky ? "open" : ""}`}
            aria-label="Scroll to top"
         >
            <i className="fas fa-angle-up"></i>
         </button>
      </>
   )
}

export default ScrollToTop;
